<template>
    <button class="y-button" type="button" v-bind="$attrs" v-on="$listeners"><slot></slot></button>
</template>

<script>
    export default {
        name: "YButton"
    }
</script>

<style scoped lang="less">
    .y-button{
        background: linear-gradient(118deg,#ffdbb4 8%, #f6d59d 84%);
        border-radius: 29px;
        border: none;
        font-size: 14px;
        font-weight: 600;
        color: #4d3621;
        height: 37px;
        width: 100%;
        &[disabled]{
            color: #C3A081 !important;
        }
        &:active {
            background: linear-gradient(
                    86deg,
                    rgb(230, 165, 101) 0%,
                    rgb(212, 114, 22) 100%
            );
        }
    }
</style>